window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};

(function($) {
  $(function() {
    REBASE.theme.protectedForm = {
      init: function() {
        var template = $('#protected_form_template').html();

        if ( sessionStorage.getItem('GH_ProtectedCollection_Validated') == '1' ) {
          setTimeout( function() {
            $(document).trigger('protected_password_validated');
          });
        } else {
          REBASE.theme.protectedForm.showProtectedForm(template);
        }
      },

      isPasswordValid: function(password) {
        return password === this.getMainPassword();
      },
      
      getMainPassword: function () {
        const  wrapper = $('#protected_form_template').attr('data-password');
        return wrapper;
      },

      showProtectedForm: function() {
        $('.product--skeleton').addClass('product--skeleton-hidden');
        $('.product-container, .product-details, .section--related-products, .section--article-slider').hide();
        $('.protected').fadeIn()
      }
    }

    $('.protected__form').on('submit', function(e) {
      e.preventDefault();

      if ( REBASE.theme.protectedForm.isPasswordValid( $(this).find('input').val() ) ) {
        sessionStorage.setItem('GH_ProtectedCollection_Validated', '1');
        $(document).trigger('protected_password_validated');
      } else {
        $('.protected__errors').html('Password invalid');
      }
    });

    $(document).on('protected_password_validated', function() {
      $('.protected').fadeOut( function() {
        $('.product-container, .product-details, .section--related-products, .section--article-slider').show();
      })
    });

    REBASE.theme.protectedForm.init();
  });
})(jQuery)
